import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../i18n/content";
import { Reveal, Overline } from "./Reveal";

export function FinalCTA() {
  const { t, pathFor } = useLang();
  return (
    <section className="relative overflow-hidden" data-testid="final-cta">
      <div className="absolute inset-0">
        <img src={IMAGES.servicesBg} alt="" aria-hidden="true" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-charcoal/55" />
      </div>
      <div className="relative mx-auto max-w-5xl px-6 py-28 text-center lg:py-40">
        <Reveal>
          <Overline className="text-gold">{t("finalCta.overline")}</Overline>
          <h2 className="mx-auto mt-6 max-w-3xl font-serif text-4xl font-light leading-tight text-cream sm:text-6xl">
            {t("finalCta.title")}
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg text-cream/80">{t("finalCta.body")}</p>
          <Link
            to={pathFor("/contact")}
            data-testid="final-cta-btn"
            className="mt-10 inline-flex rounded-full bg-terracotta px-9 py-4 text-sm font-semibold text-white transition-colors duration-300 hover:bg-terracotta-deep"
          >
            {t("cta.book")}
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
